import {maxLength, required} from '@vuelidate/validators';
import {ref} from 'vue';
import type {FormElementItem} from '~/lib/types/formTypes';
import type {ExistingResponsibleCommand, NewResponsibleCommand} from '~/lib/types/responsibleTypes';

export const responsibleCommandLabels = {
	fullName: 'Naam'
} satisfies Partial<Record<keyof (ExistingResponsibleCommand | NewResponsibleCommand), string>>;

export const useResponsiblesForm = (initialValue?: ExistingResponsibleCommand) => {

	const formSchema: Array<FormElementItem> = [
		{
			type: 'text',
			label: 'Naam',
			key: 'fullName',
			validators: {
				required,
				maxLength: maxLength(255)
			}
		}
	];

	const getFormFields = (): NewResponsibleCommand | ExistingResponsibleCommand => {
		if (!initialValue) {
			return {
				tag: 'NEW',
				fullName: ''
			} satisfies NewResponsibleCommand;
		}
		return initialValue;
	};

	const formFields = ref(getFormFields());

	return {
		formSchema,
		formFields
	};
};
